import React, { useState } from 'react';
import './RegisterWebinar.css';

const SOURCE_OPTIONS = [
  'Friend / Family Referral',
  'School / College Recommendation',
  'Google Search',
  'Social Media (Instagram / Facebook)',
  'YouTube',
  'LinkedIn',
  'WhatsApp',
  'Newspaper / Magazine',
  'Event / Hackathon',
  'ibots Website',
  'Other',
];

const errStyle = { color: '#e8394d', fontSize: '11px', marginTop: '4px' };

function RegisterWebinar({ onClose }) {
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    fullName: '', phone: '', email: '', iAmA: '',
    school: '', city: '', learn: '',
    source: '', customSource: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = 'Full name is required';
    if (!formData.phone) newErrors.phone = 'Phone number is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.source) newErrors.source = 'Please tell us how you heard about ibots';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      await fetch('http://localhost:5000/api/enquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          formType: 'webinar-register',
          fullName: formData.fullName,
          phone:    formData.phone,
          email:    formData.email,
          iAmA:     formData.iAmA,
          school:   formData.school,
          city:     formData.city,
          learn:    formData.learn,
          source:   formData.source === 'Other' ? formData.customSource : formData.source,
        }),
      });
    } catch (err) {
      console.log('Your backend error:', err);
    }

    try {
      await fetch('http://localhost:5000/api/webinar', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name:        formData.fullName,
          type:        formData.iAmA === 'college-student' ? 'College' : 'School',
          phone:       formData.phone,
          email:       formData.email,
          institution: formData.school || '',
          city:        formData.city || '',
          interest:    formData.learn || '',
          source:      formData.source === 'Other' ? formData.customSource : formData.source,
          formType:    'webinar-register',
        }),
      });
    } catch (err) {
      console.log('Webinar dashboard error:', err);
    }

    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="rw__overlay" onClick={onClose}>
        <div className="rw__box" onClick={(e) => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center', gap: '16px' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#dcfce7', color: '#16a34a', fontSize: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900 }}>✓</div>
          <h2 style={{ color: '#0d2e6e', fontWeight: 900, margin: 0 }}>Thank You for Reaching Out to ibots!</h2>
          <p style={{ color: '#64748b', margin: 0, maxWidth: '300px', lineHeight: '1.6' }}>You have been successfully registered for the free webinar. The Zoom link will be sent to your email <strong>30 minutes before</strong> the session.</p>
          <button className="rw__submit" onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }

  return (
    <div className="rw__overlay" onClick={onClose}>
      <div className="rw__box" onClick={(e) => e.stopPropagation()}>

        <button className="rw__close" onClick={onClose}>✕</button>

        <div className="rw__title-row">
          <span className="rw__dot"></span>
          <h2 className="rw__title">Register for Free Webinar</h2>
          <span className="rw__free-badge">FREE</span>
        </div>

        <div className="rw__info-box">
          <p className="rw__info-topic">THIS SATURDAY'S TOPIC</p>
          <p className="rw__info-headline">"Introduction to Robotics — Build Your First Robot from Scratch"</p>
          <div className="rw__info-meta">
            <span>Every Saturday</span>
            <span className="rw__dot-sep">·</span>
            <span>10:00 AM – 11:30 AM</span>
            <span className="rw__dot-sep">·</span>
            <span>Live on Zoom / Google Meet</span>
            <span className="rw__dot-sep">·</span>
            <span>Free to attend</span>
          </div>
        </div>

        <div className="rw__form">
          <div className="rw__row">
            <div className="rw__group">
              <label className="rw__label">Full Name *</label>
              <input type="text" name="fullName" value={formData.fullName}
                onChange={handleChange} placeholder="Enter your full name" className="rw__input" />
              {errors.fullName && <p style={errStyle} className="error-field">{errors.fullName}</p>}
            </div>
            <div className="rw__group">
              <label className="rw__label">Phone Number *</label>
              <input type="text" name="phone" value={formData.phone}
                onChange={handleChange} placeholder="+91 XXXXX XXXXX" className="rw__input" />
              {errors.phone && <p style={errStyle} className="error-field">{errors.phone}</p>}
            </div>
          </div>

          <div className="rw__row">
            <div className="rw__group">
              <label className="rw__label">Email Address * <span className="rw__label-note">(Zoom link sent here)</span></label>
              <input type="email" name="email" value={formData.email}
                onChange={handleChange} placeholder="you@example.com" className="rw__input" />
              {errors.email && <p style={errStyle} className="error-field">{errors.email}</p>}
            </div>
            <div className="rw__group">
              <label className="rw__label">I Am A</label>
              <select name="iAmA" value={formData.iAmA}
                onChange={handleChange} className="rw__input rw__select">
                <option value="">Select...</option>
                <option value="student">Student</option>
                <option value="parent">Parent</option>
                <option value="teacher">Teacher</option>
                <option value="school">School / Institution</option>
                <option value="other">Other</option>
              </select>
              {errors.iAmA && <p style={errStyle} className="error-field">{errors.iAmA}</p>}
            </div>
          </div>

          <div className="rw__row">
            <div className="rw__group">
              <label className="rw__label">School / College</label>
              <input type="text" name="school" value={formData.school}
                onChange={handleChange} placeholder="Institution name (optional)" className="rw__input" />
            </div>
            <div className="rw__group">
              <label className="rw__label">City</label>
              <input type="text" name="city" value={formData.city}
                onChange={handleChange} placeholder="e.g. Coimbatore" className="rw__input" />
            </div>
          </div>

          <div className="rw__group rw__group--full">
            <label className="rw__label">What do you hope to learn? (optional)</label>
            <textarea name="learn" value={formData.learn} onChange={handleChange}
              placeholder="e.g. How to build robots, start learning electronics at home..."
              className="rw__input rw__textarea" />
          </div>

          <div className="rw__group rw__group--full">
            <label className="rw__label">How did you hear about ibots? *</label>
            <select name="source" value={formData.source}
              onChange={handleChange} className="rw__input rw__select">
              <option value="">Select...</option>
              {SOURCE_OPTIONS.map((s) => (<option key={s} value={s}>{s}</option>))}
            </select>
            {errors.source && <p style={errStyle}>{errors.source}</p>}
            {formData.source === 'Other' && (
              <input type="text" name="customSource" value={formData.customSource}
                onChange={handleChange} placeholder="Please tell us how you found us..."
                className="rw__input" style={{ marginTop: '8px' }} />
            )}
          </div>

          <button className="rw__submit" onClick={handleSubmit}>
            Confirm My Free Spot →
          </button>

          <p className="rw__footer">
            Your details are safe · Zoom link sent 30 mins before · Every Saturday without fail
          </p>
        </div>
      </div>
    </div>
  );
}

export default RegisterWebinar;